export default __webpack_public_path__ + "static/media/carrousel_capacitador.3813bc60.png";